import * as React from 'react';
import { IconProps } from '../types';
import srcImg from '../../assets/images/venmo.png';

const IcPaymentTypeVenmo = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <image href={srcImg} width="24" height="24" />
  </svg>
);

export default IcPaymentTypeVenmo;
